import { GLOBAL_HANDLER_ID_ATTRIBUTE, REFERENCE_ID_SELECTOR } from 'consts';
import { isTruthy } from '@ardoq/common-helpers';
import { REFERENCE_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { getNodeUrlFieldValues, UrlFieldValueList } from '@ardoq/graph';
import type { ViewIds } from '@ardoq/api-types';
import { HasUrlFieldValuesById } from './types';

const urlFieldValuesPopover =
  ({
    urlFieldValuesByComponentId,
    urlFieldValuesByReferenceId,
    viewId,
  }: HasUrlFieldValuesById & { viewId: ViewIds }) =>
  (element: Element | null) => {
    const componentId = element
      ?.closest(`.component[${GLOBAL_HANDLER_ID_ATTRIBUTE}]`)
      ?.getAttribute(GLOBAL_HANDLER_ID_ATTRIBUTE);

    const referenceIds =
      element
        ?.closest(REFERENCE_ID_SELECTOR)
        ?.getAttribute(REFERENCE_ID_ATTRIBUTE)
        ?.split(',') ??
      [
        element
          ?.closest(`.integration[${GLOBAL_HANDLER_ID_ATTRIBUTE}]`)
          ?.getAttribute(GLOBAL_HANDLER_ID_ATTRIBUTE),
      ].filter(isTruthy);

    const urlFieldValues = getNodeUrlFieldValues(
      componentId,
      referenceIds,
      urlFieldValuesByComponentId,
      urlFieldValuesByReferenceId
    );
    if (!urlFieldValues.length) {
      return null;
    }
    return (
      <UrlFieldValueList urlFieldValues={urlFieldValues} viewId={viewId} />
    );
  };
export { urlFieldValuesPopover };
